import { DataSelector, type } from './DataSelector';

class CustomFormFields {
  constructor(formFields) {
    formFields.register(type, DataSelector);
  }
}


export default {
  __init__: [ 'selectData' ],
  selectData: [ 'type', CustomFormFields ]
};